"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _NoticeAttachmentBlock = _interopRequireDefault(require("../NoticeAttachmentBlock"));
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const NoticeAttachmentList = ({
  attachments,
  onDownload
}) => {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Fragment, {
    children: attachments && attachments.length > 0 && /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.ListWrapper, {
      children: attachments.map((file, index) => /*#__PURE__*/(0, _jsxRuntime.jsx)(_NoticeAttachmentBlock.default, {
        type: file.mimetype,
        name: file.filename,
        description: "Trykk her for \xE5 laste ned",
        onDownload: onDownload ? () => onDownload(file) : undefined
      }, index))
    })
  });
};
var _default = exports.default = NoticeAttachmentList;